import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoUrl from '../assets/Best_National_Carports-logo-blk.svg';

const COMPANY_COLOR = [41, 128, 185]; // Blue accent
const TEXT_COLOR = [44, 62, 80]; // Dark grey
const HEADER_BG = [245, 247, 250]; // Very light grey

// DocuSign Anchor Tagging strings (AutoPlace tabs)
// DocuSign scans the document for these strings and places tabs accordingly.
// Examples: \s1\ = Signer 1 signature, \i1\ = Signer 1 initials, \d1\ = Signer 1 date signed.
const DS_ANCHORS = {
  SIGN_1: '\\s1\\',
  INIT_1: '\\i1\\',
  DATE_1: '\\d1\\',
};

// Terms content (kept as text for crisp rendering and DocuSign anchor scanning)
const TERMS_TITLE = 'Terms of Sales Agreement';
const TERMS_SECTIONS = [
  {
    heading: 'Payment.',
    body:
      'Unless otherwise agreed in writing, all amounts are due upon delivery of materials to the site and before beginning installation. Any amount not paid when due is subject to a late fee of 1% of the balance due and an interest rate of 20.00% per month. Customer agrees to pay all costs of collection, lien filing fees, litigation expenses, court costs, and attorney fees incurred in Company’s collection efforts. Customer authorizes Company to run Customer’s credit card, debit card, or other payment source for $1.00 at the time Company accepts Customer’s offer or anytime thereafter to ensure availability of funds and payment method.',
  },
  {
    heading: 'Credit Card Chargeback.',
    body:
      'Customer consents and agrees to submit their credit card information and to be charged by Company at the rates set forth herein until Customer instructs Company, in writing, to stop charging. To the greatest extent allowed by law, Customer hereby waives any right to chargeback or other dispute of any credit card charge made by Company.',
  },
  {
    heading: 'Payment Methods.',
    body:
      'All orders are C.O.D. payable by cashier’s check, money order, Visa, or MasterCard (3% of the balance will be added using any type of credit or debit card). All cashier’s checks or money orders must be payable to Best National Carports. We do not accept personal checks nor business checks. Notwithstanding anything else to the contrary, if Customer breaches any of its contractual obligations herein contained, Company may terminate this contract and apply Customer deposit towards the total amount owed Company.',
  },
  {
    heading: 'Excess Materials.',
    body:
      'Until materials delivered are installed and become part of the structure, they remain the property of the Company. Any excess or unused materials remain the property of Company which Company may use or dispose of as it chooses.',
  },
  {
    heading: 'Limited Warranty.',
    body:
      'As to all structures, Company warrants that its installation of the structure will be free of defects in workmanship. As to 12-gauge and 12-gauge certified structures, Company warrants the framing against holes formed by corrosion for twenty (20) years from installation, provided Customer has made reasonable efforts to care for, protect, and maintain the structure. This limited warranty does NOT apply to 14 Gauge or any other material. BNC warranty, for a period of three-hundred and sixty-five (365) calendar days from the date of complete installation, against defects in workmanship assuming normal care and maintenance. The warranty does not cover roof leaks on horizontal units longer than thirty-one (31) feet in length.',
  },
  {
    heading: 'Notice.',
    body:
      'Mobile home anchors cannot be installed in rocky or hardpan soils. As such, where rocky soils exist, rock anchors may be used in place of mobile home anchors. The Customer is responsible for communicating to the Company whether site soils are rocky before obtaining a building permit and before delivery of materials to the site. If mobile home anchors are delivered to the site and are not installed due to rocky ground, the Customer must pay the cost of purchase, delivery, and installation of rock anchors. During this time Customer is liable for securing the building until the Company returns to the site to install the rock anchors.',
  },
  {
    heading: '',
    body:
      'Any alterations to the structure by the Customer or by another at its direction other than proper maintenance will immediately void all warranties. Alterations include but are not limited to any interior or exterior modifications, running electricity, or plumbing in the unit. Best National Carports is not responsible for repair leaks under base-rail (area around the 4 walls when unit is fully enclosed or 2 walls when unit is partially enclosed). If any additions are made after the building is completed then it VOIDS all warranties. The installation of a ceiling fan anywhere on the structure, no matter how it is installed VOIDS all warranties.',
  },
  {
    heading: 'Warranty Disclaimer.',
    body:
      'There are no warranties which extend beyond the description on the face of this document. The warranties in this agreement are in lieu of all other warranties express or implied, including without limitation, any warranties of merchantability, or fitness for a particular purpose, which are expressly disclaimed.',
  },
  {
    heading: 'Remedy.',
    body:
      'Customer agrees that its sole and exclusive remedy against Company will be limited to the repair and replacement of nonconforming goods at the warrantor’s option, provided Company is notified in writing of any defect. However, warrantor will not elect refund unless it is unable to provide replacement, repair is not commercially practicable and cannot be made within the time of performance. This exclusive remedy is effective so long as Company is willing and able to repair/replace the defective parts. Company’s liability for any damages due to Customer will be limited to the purchase price of the goods. THIS PARAGRAPH STATES CUSTOMER’S SOLE AND EXCLUSIVE REMEDY FOR BREACH OF WARRANTY.',
  },
  {
    heading: 'Limitation of Liability.',
    body:
      'Liability is limited to an amount not to exceed the purchase price of the goods should there ever be any damages, including but not limited to, contract damages, damages arising from injuries to persons or property, breach of warranty, negligence, strict liability, or other tort(s), with respect to the goods or services in connection with the goods. Customer agrees that in no event will Company be liable to Customer and/or any third parties for any incidental damages, consequential damages, special damages, exemplary damages, or labor charges, including without limitation lost revenues and profits, even if Company has been advised of the possibility of such damages.',
  },
  {
    heading: 'Warranty limited to Original Purchaser.',
    body:
      'This warranty extends only to the original purchaser of the product warranted by this document. Said warranty is nontransferable and non-assignable by Customer.',
  },
  {
    heading: 'Certified vs Standard Structures',
    body:
      'Certified structure: A certified carport or structure will be installed using engineer drawings. The cost of obtaining these drawings will be the full responsibility of the Customer and is above and in addition to the total structure or carport price for an additional nonrefundable fee which must be paid in advance.\n\nStandard (non-certified) structure: A standard carport or structure is not built according to engineer drawings and will not have braces at every post. Customer assumes all liability in having this type of structure installed as it pertains to issues such as but not limited to: snow load and building permits.',
  },
  {
    heading: 'Additional Fees',
    body:
      'If the structure is to be built on any wall, dock, or other base 12 inches or taller or installed over an existing structure, there will be an additional charge. Any site improvements, leveling, excavating, draining, retaining, etc. performed by Company or its contractors will be billed separately to Customer and Customer agrees to pay for such improvements.\n\nThe Customer must be aware that if the installation location is more than one hundred (100) feet away from where the crew must unload there will be an additional fee. Buildings that have paneling on the side must be eighteen (18) inches around the building area to be able to enclose. If eighteen (18) inches is not available extra labor may be done for an additional fee.',
  },
  {
    heading: 'General Legal Terms',
    body:
      'Counterparts and Photocopies. This agreement may be signed in multiple counterpart copies, each of which shall constitute an original, with the same force and effect as if each of the parties hereto has signed a single instrument. A photocopy or facsimile of such signed counterparts shall be deemed an original.\n\nGoverning Law, Jurisdiction, and Venue. This agreement shall be governed exclusively by the laws of California without giving effect to any choice of law or conflict of law rules or appellate decisions of any state. Any lawsuit between the parties to this agreement shall be brought and maintained exclusively in the Yuba County Superior Court of California United States (215 5th St, Marysville, CA 95901) and the parties hereby submit to the jurisdiction of such courts.\n\nRecovery of Attorney’s Fees and Costs. To the extent otherwise permissible by law, Best National Carports reserves the right to recover attorney’s fees and reasonable expenses arising out of any cause of action for Best National Carports is successful and/or involved with in any shape or manner. Customer agrees to pay attorney’s fees and reasonable expenses for Best National Carports.\n\nModifications. Any modifications/alterations done to the structure will void all certification on the unit, relieving Best National Carports of any liability for damages to the structure or any surrounding property of the Customer.\n\nInsurance. Structure shall be added to Customer’s Homeowners Insurance upon completion of installation.\n\nSeverability. If any one or more provisions of this agreement are unenforceable, the parties agree that the remaining provisions found herein will still be enforceable.\n\nEntire Agreement. This Agreement constitutes the complete agreement of the parties and may only be modified by a written document signed by all parties hereto. All prior descriptions, representations, negotiations, or agreements are merged herein and superseded hereby. The Customer is not relying upon any promise, representation, or warranty not expressly stated herein.',
  },
];

const getImageDataUrl = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => {
      console.warn("Failed to load logo image");
      resolve(null);
    };
  });
};

/**
 * Appends Terms pages compatible with DocuSign “Anchor Tagging”.
 *
 * Notes:
 * - A PDF alone cannot “activate the signature tool on click” like a web form.
 *   In DocuSign, the signer clicks the DocuSign tab. These anchor strings let
 *   DocuSign auto-place those tabs when you send the PDF.
 */
const appendTermsForDocuSign = (doc) => {
  const PAGE_WIDTH = doc.internal.pageSize.getWidth();
  const PAGE_HEIGHT = doc.internal.pageSize.getHeight();

  const MARGIN_X = 14;
  const MARGIN_TOP = 18;
  const MARGIN_BOTTOM = 18;
  const CONTENT_WIDTH = PAGE_WIDTH - MARGIN_X * 2;

  const LINE_H = 5;
  const FOOTER_RESERVED = 14; // reserved area for initials line
  const BOTTOM_LIMIT = PAGE_HEIGHT - MARGIN_BOTTOM - FOOTER_RESERVED;

  const drawTermsHeader = (continued = false) => {
    // light header (kept simple for readability + compatibility)
    doc.setTextColor(...TEXT_COLOR);
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text(`${TERMS_TITLE}${continued ? ' (continued)' : ''}`, MARGIN_X, MARGIN_TOP);
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
  };

  const drawInitialsLine = () => {
    const y = PAGE_HEIGHT - 10;
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    // DocuSign anchor for initials (Signer 1)
    doc.text(`Customer Initials: ____________________  ${DS_ANCHORS.INIT_1}`, MARGIN_X, y);
    doc.setTextColor(...TEXT_COLOR);
    doc.setFontSize(10);
  };

  const newTermsPage = (continued = true) => {
    // Finish the current Terms page with initials
    drawInitialsLine();
    doc.addPage();
    drawTermsHeader(continued);
    return MARGIN_TOP + 10;
  };

  const ensureSpace = (neededH, y) => {
    if (y + neededH <= BOTTOM_LIMIT) return y;
    return newTermsPage(true);
  };

  // Always start Terms on a clean page (even if table ends mid-page)
  doc.addPage();
  drawTermsHeader(false);
  let y = MARGIN_TOP + 10;

  TERMS_SECTIONS.forEach((sec) => {
    if (sec.heading) {
      y = ensureSpace(LINE_H * 2, y);
      doc.setFont(undefined, 'bold');
      doc.text(sec.heading, MARGIN_X, y);
      y += LINE_H;
    }

    doc.setFont(undefined, 'normal');
    const paragraphs = String(sec.body || '').split('\n\n');
    paragraphs.forEach((p) => {
      const lines = doc.splitTextToSize(p, CONTENT_WIDTH);
      const blockH = lines.length * LINE_H;
      y = ensureSpace(blockH + LINE_H, y);
      doc.text(lines, MARGIN_X, y);
      y += blockH + LINE_H;
    });

    y += 2;
  });

  // Signature block (DocuSign anchor tagging)
  y = ensureSpace(70, y);

  doc.setFont(undefined, 'bold');
  doc.setFontSize(11);
  doc.text('Customer Name (Print)', MARGIN_X, y);
  y += 8;
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.line(MARGIN_X, y, PAGE_WIDTH - MARGIN_X, y);
  y += 12;

  doc.setFont(undefined, 'bold');
  doc.text('Customer Signature', MARGIN_X, y);
  y += 6;
  doc.setFont(undefined, 'normal');

  // Signature box
  const boxH = 22;
  doc.setDrawColor(100);
  doc.rect(MARGIN_X, y, CONTENT_WIDTH, boxH);

  // Visible cue + DocuSign signature anchor (Signer 1)
  doc.setFontSize(11);
  doc.setTextColor(140, 140, 140);
  doc.text('Sign Here', PAGE_WIDTH - MARGIN_X - 2, y + 14, { align: 'right' });
  // Place anchor near top-left inside box (keep it subtle but readable)
  doc.setFontSize(8);
  doc.text(DS_ANCHORS.SIGN_1, MARGIN_X + 2, y + 5);
  doc.setTextColor(...TEXT_COLOR);
  doc.setFontSize(10);
  y += boxH + 10;

  // Date line + DocuSign date anchor (Signer 1)
  doc.setFont(undefined, 'bold');
  doc.text('Date', MARGIN_X, y);
  doc.setFont(undefined, 'normal');
  // Anchor placed after the line label
  doc.setFontSize(8);
  doc.setTextColor(140, 140, 140);
  doc.text(DS_ANCHORS.DATE_1, MARGIN_X + 18, y);
  doc.setTextColor(...TEXT_COLOR);
  doc.setFontSize(10);
  y += 8;
  doc.line(MARGIN_X, y, MARGIN_X + 70, y);

  // Initials on the final Terms page as well
  drawInitialsLine();
};

export const generateContractPDF = async (order) => {
  const doc = new jsPDF();
  const client = order.client || {};
  const metadata = order.metadata || {};
  
  const safeJsonParse = (jsonString, defaultValue = {}) => {
    if (!jsonString || typeof jsonString !== 'string') return defaultValue;
    try {
      return JSON.parse(jsonString);
    } catch (error) {
      console.error('Failed to parse JSON string:', error);
      return defaultValue;
    }
  };

  // --- Parse Data (Matching OrderDetails.js logic) ---
  const centerSectionData = safeJsonParse(metadata.centerSection);
  const leftLeanToData = safeJsonParse(metadata.leftLeanTo);
  const rightLeanToData = safeJsonParse(metadata.rightLeanTo);
  const frontLeanToData = safeJsonParse(metadata.frontLeanTo);
  const backLeanToData = safeJsonParse(metadata.backLeanTo);
  
  const centerStorageData = safeJsonParse(metadata.centerStorage);
  const leftLeanStorageData = safeJsonParse(metadata.leftLeanStorage);
  const rightLeanStorageData = safeJsonParse(metadata.rightLeanStorage);
  const frontLeanStorageData = safeJsonParse(metadata.frontLeanStorage);
  const backLeanStorageData = safeJsonParse(metadata.backLeanStorage);

  const colorsData = safeJsonParse(metadata.colors);

  // --- Helper to filter empty values ---
  const hasValue = (val) => val && val !== 'N/A' && val !== 'undefined' && val.toString().trim() !== '';

  // --- Helper to format currency ---
  const formatCurrency = (amount) => {
      const num = parseFloat(amount);
      if (isNaN(num)) return '-';
      return '$' + num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  };

  const getPriceById = (priceArray, id) => {
      if (!Array.isArray(priceArray)) return 0;
      const item = priceArray.find(p => p.id === id);
      return item ? item.price : 0;
  };
  
  const priceData = safeJsonParse(metadata.price, []);

  // --- Helper to generate rows for Items (Walls, Windows, Doors, etc) ---
  const generateItemRows = (items, sidePrefix = '') => {
      if (!items) return [];
      const rows = [];

      // Helper to format a single item
      const formatItemRow = (item, sideOverride = '') => {
          let label = 'Item';
          if (item.categoryLabel) {
              label = item.categoryLabel;
          } else if (item.type && typeof item.type === 'string' && isNaN(parseInt(item.type))) {
              label = item.type;
          } else if (item.position?.wall) {
               label = `${item.position.wall} Wall`;
          }
          // Capitalize label
          label = label.charAt(0).toUpperCase() + label.slice(1);
          
          let description = item.name;
          const qty = parseInt(item.quantity) || 1;
          if (qty > 1) {
              description += ` (Qty: ${qty})`;
          }

          const priceVal = parseFloat(item.totalPrice) || parseFloat(item.price) || 0;
          
          return [label, description, formatCurrency(priceVal)];
      };

      // 1. Grouped Object (front, back, left, right...)
      if (!Array.isArray(items) && typeof items === 'object') {
          const keys = ['front', 'back', 'left', 'right', 'roof', 'storage'];
          keys.forEach(side => {
              const sideItems = items[side];
              if (Array.isArray(sideItems) && sideItems.length > 0) {
                  const validItems = sideItems.filter(i => i && i.name);
                  if (validItems.length > 0) {
                      // Add Section Header for the side
                      rows.push([{ content: `${side.charAt(0).toUpperCase() + side.slice(1)} Wall Items`, colSpan: 3, styles: { fontStyle: 'italic', textColor: [100, 100, 100], fillColor: [250, 250, 250] } }]);
                      
                      validItems.forEach(item => {
                          rows.push(formatItemRow(item, side));
                      });
                  }
              }
          });
      } 
      // 2. Flat Array
      else if (Array.isArray(items)) {
          items.filter(i => i && i.name).forEach(item => {
              rows.push(formatItemRow(item));
          });
      }

      return rows;
  };

  // --- Helper to Generate Rows from Price Array (New logic) ---
  const generateRowsFromPriceArray = (priceArray) => {
      if (!priceArray || !Array.isArray(priceArray)) return [];
      const rows = [];
      
      priceArray.forEach(item => {
          let label = '';
          let description = '';
          const priceStr = formatCurrency(item.price);

          // Map IDs/Names to readable Labels
          switch(item.id) {
              case 'basePrice': 
                  label = 'Base Structure'; 
                  description = 'Base price';
                  break;
              case 'legPrice':
                  label = 'Leg Height';
                  description = 'Additional height cost';
                  break;
              case 'roofPrice':
                  label = 'Roof Style';
                  description = 'Vertical Roof upgrade';
                  break;
              case 'frontWallPrice': label = 'Front Wall'; break;
              case 'backWallPrice': label = 'Back Wall'; break;
              case 'leftWallPrice': label = 'Left Wall'; break;
              case 'rightWallPrice': label = 'Right Wall'; break;
              case 'item':
              case 'window':
              case 'door':
              case 'rollUpDoor':
              case 'frameout':
                  label = item.categoryLabel || 'Item'; // Fallback
                  // Attempt to guess label if categoryLabel missing
                  if (item.name && item.name.toLowerCase().includes('window')) label = 'Window';
                  else if (item.name && item.name.toLowerCase().includes('door')) label = 'Door';
                  
                  description = item.name;
                  if (item.quantity && item.quantity > 1) {
                      description += ` (Qty: ${item.quantity})`;
                  }
                  break;
              default:
                  label = item.name || 'Extra';
                  description = item.description || '';
          }
          
          if (!description && label) description = label;
          if (item.id === 'item' && item.name) {
             label = 'Item'; // General items
             // Refine Item Label
             if(item.name.includes("x") || item.name.includes("X")) label = "Component"; 
          }

          rows.push([label, description, priceStr]);
      });

      return rows;
  };

  // --- Header ---
  // doc.setFillColor(...HEADER_BG);
  // doc.rect(0, 0, 210, 45, 'F');
  
  // Header bottom border
  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.5);
  doc.line(14, 45, 196, 45);

  const logoData = await getImageDataUrl(logoUrl);
  if (logoData) {
      // User requested 250px x 66.55px
      // Converting px to mm approximately (assuming 72dpi or just scaling relative to A4)
      // jsPDF units are mm by default.
      // 250px at 72dpi is ~88mm. 66.55px is ~23.5mm.
      // Let's assume the user meant pixel values relative to generic web, mapping to reasonable mm size.
      // 250/4 = 62.5mm? let's guess a reasonable width.
      // Standard A4 is 210mm wide. 250px on screen is about 1/4 - 1/3 viewport. 
      // Let's try to map strictly if "px" was specified for PDF context, but usually we deal in mm.
      // 1px = 0.264583 mm
      const w_mm = 250 * 0.264583; // ~66mm
      const h_mm = 66.55 * 0.264583; // ~17.6mm
      
      doc.addImage(logoData, 'PNG', 14, 15, w_mm, h_mm); 
  } else {
      doc.setTextColor(...TEXT_COLOR);
      doc.setFontSize(20);
      doc.text('Best National Carports', 14, 28);
  }

  doc.setTextColor(...COMPANY_COLOR);
  doc.setFontSize(22);
  doc.setFont(undefined, 'bold');
  doc.text('CONTRACT', 196, 22, { align: 'right' });
  
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.setTextColor(100, 100, 100);
  if (hasValue(order.reference)) doc.text(`Reference: #${order.reference}`, 196, 30, { align: 'right' });
  doc.text(`Date: ${new Date().toLocaleDateString()}`, 196, 35, { align: 'right' });

  // --- Client & Order Info ---
  // ... (Same as before, keep compact) ...
  doc.setTextColor(...TEXT_COLOR);
  let yPos = 60;
  
  doc.setFontSize(12);
  doc.setFont(undefined, 'bold');
  doc.text('Client Information', 14, yPos);
  
  yPos += 8;
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');

  const clientLines = [];
  if (hasValue(client.firstName) || hasValue(client.lastName)) clientLines.push(client.firstName + ' ' + (client.lastName || ''));
  if (hasValue(client.companyName)) clientLines.push(client.companyName);
  if (hasValue(client.email)) clientLines.push(client.email);
  if (hasValue(client.phoneNumber)) clientLines.push(client.phoneNumber);
  
  let addressLine = '';
  if (hasValue(client.address)) addressLine += client.address;
  let cityStateZip = '';
  if (hasValue(client.city)) cityStateZip += client.city;
  if (hasValue(client.state)) cityStateZip += (cityStateZip ? ', ' : '') + client.state;
  if (hasValue(client.zipCode)) cityStateZip += ' ' + client.zipCode;
  if (addressLine) clientLines.push(addressLine);
  if (cityStateZip) clientLines.push(cityStateZip);

  clientLines.forEach((line, i) => doc.text(line, 14, yPos + (i * 5)));

  // Top-level summary
  const summaryLines = [
      `Model: ${metadata.model || '-'}`,
      `Roof Style: ${metadata.roofStyle || '-'}`,
      `Install Surface: ${metadata.installationSurface || '-'}`
  ];
  summaryLines.forEach((line, i) => doc.text(line, 110, yPos + (i * 5)));

  yPos += Math.max(clientLines.length, summaryLines.length) * 5 + 15;

  // --- STRUCTURE DETAILS TABLE ---
  doc.setFontSize(12);
  doc.setFont(undefined, 'bold');
  doc.text('Structure Details', 14, yPos);
  yPos += 4;

  let structureRows = [];

  // 1. BASE CONFIG
  structureRows.push([{ content: 'BASE CONFIGURATION', colSpan: 3, styles: { fontStyle: 'bold', fillColor: [240, 240, 240] } }]);
  if(hasValue(metadata.model)) structureRows.push(['Model', metadata.model, '']);
  if(hasValue(metadata.installationSurface)) structureRows.push(['Installation Surface', metadata.installationSurface, '']);
  if(hasValue(metadata.roofStyle)) structureRows.push(['Roof Style', metadata.roofStyle, '']);
  if(hasValue(metadata.roofPitch)) structureRows.push(['Roof Pitch', metadata.roofPitch, '']);
  if(hasValue(metadata.gauge)) structureRows.push(['Gauge', metadata.gauge, '']);
  if(metadata.certified) structureRows.push(['Certified', 'Yes', '']);

  // 2. CENTER BUILDING
  structureRows.push([{ content: 'CENTER BUILDING', colSpan: 3, styles: { fontStyle: 'bold', fillColor: [240, 240, 240] } }]);
  const csSize = centerSectionData.size || {};
  if(csSize.width) structureRows.push(['Size', `${csSize.width}'W x ${csSize.length || csSize.lenght || 0}'L`, '']);
  if(csSize.height) structureRows.push(['Height', `${csSize.height}'H`, '']);
  
  // Use Price Array if available
  if (centerSectionData.price && Array.isArray(centerSectionData.price)) {
      structureRows = [...structureRows, ...generateRowsFromPriceArray(centerSectionData.price)];
  } else {
      // Fallback
      if(hasValue(centerSectionData.sidesAndEnds?.frontWall)) structureRows.push(['Front Wall', centerSectionData.sidesAndEnds.frontWall, '']);
      if(hasValue(centerSectionData.sidesAndEnds?.backWall)) structureRows.push(['Back Wall', centerSectionData.sidesAndEnds.backWall, '']);
      if(hasValue(centerSectionData.sidesAndEnds?.leftWall)) structureRows.push(['Left Wall', centerSectionData.sidesAndEnds.leftWall, '']);
      if(hasValue(centerSectionData.sidesAndEnds?.rightWall)) structureRows.push(['Right Wall', centerSectionData.sidesAndEnds.rightWall, '']);
      structureRows = [...structureRows, ...generateItemRows(centerSectionData.items)];
  }

  // 3. LEAN-TOS
  const addLeanToSection = (title, data) => {
      if (data && data.leanTo) {
          structureRows.push([{ content: title.toUpperCase(), colSpan: 3, styles: { fontStyle: 'bold', fillColor: [240, 240, 240] } }]);
          const size = data.size || {};
          if(size.width) structureRows.push(['Size', `${size.width}'W x ${size.length || size.lenght || 0}'L`, '']);
          if(size.height) structureRows.push(['Height', `${size.height}'H`, '']);
          
          if (data.price && Array.isArray(data.price)) {
              structureRows = [...structureRows, ...generateRowsFromPriceArray(data.price)];
          } else {
              structureRows = [...structureRows, ...generateItemRows(data.items)];
          }
      }
  };

  addLeanToSection('Right Lean-To', rightLeanToData);
  addLeanToSection('Left Lean-To', leftLeanToData);
  addLeanToSection('Front Lean-To', frontLeanToData);
  addLeanToSection('Back Lean-To', backLeanToData);

  // 4. STORAGE
  const addStorageSection = (title, data) => {
      if (data && data.length && data.length !== 'none') {
           structureRows.push([{ content: title.toUpperCase(), colSpan: 3, styles: { fontStyle: 'bold', fillColor: [240, 240, 240] } }]);
           structureRows.push(['Length', `${data.length}'L`, '']);
           if(data.location) structureRows.push(['Location', data.location, '']);
      }
  };

  addStorageSection('Center Storage', centerStorageData);
  addStorageSection('Left Lean-To Storage', leftLeanStorageData);
  addStorageSection('Right Lean-To Storage', rightLeanStorageData);
  addStorageSection('Front Lean-To Storage', frontLeanStorageData);
  addStorageSection('Back Lean-To Storage', backLeanStorageData);

  // 5. COLORS
  structureRows.push([{ content: 'COLORS', colSpan: 3, styles: { fontStyle: 'bold', fillColor: [240, 240, 240] } }]);
  const colors = colorsData || {};
  if(colors.roof?.name) structureRows.push(['Roof Color', colors.roof.name, '']);
  if(colors.trim?.name) structureRows.push(['Trim Color', colors.trim.name, '']);
  if(colors.sideWalls?.name) structureRows.push(['Side Wall Color', colors.sideWalls.name, '']);
  if(colors.endWalls?.name) structureRows.push(['End Wall Color', colors.endWalls.name, '']);


  autoTable(doc, {
    startY: yPos,
    head: [['Item', 'Description', 'Price']],
    body: structureRows,
    theme: 'plain',
    styles: { fontSize: 9, cellPadding: 3, textColor: TEXT_COLOR, lineColor: [220, 220, 220], lineWidth: { bottom: 0.1 } },
    headStyles: { 
        fillColor: [255, 255, 255], 
        textColor: COMPANY_COLOR, 
        fontStyle: 'bold',
        lineWidth: { bottom: 0.5 },
        borderColor: [200, 200, 200]
    },
    columnStyles: {
        0: { fontStyle: 'bold', width: 80 },
        2: { halign: 'right' }
    }
  });

  // --- Price Summary ---
  const requestPriceSummary = safeJsonParse(metadata.priceSummary);
  
  // Use priceData (parsed metadata.price) as fallback if it has the new structure
  const useNewStructure = !requestPriceSummary.subTotal && priceData.subTotalPrice;

  // Fallback to order properties if metadata summary is missing
  const summaryData = {
      subTotal: requestPriceSummary.subTotal || (useNewStructure ? priceData.subTotalPrice : order.itemsAmount) || 0,
      tax: requestPriceSummary.taxAmount || (useNewStructure ? priceData.taxAmount : order.taxAmount) || 0,
      total: requestPriceSummary.estimatedTotal || (useNewStructure ? priceData.totalPrice : order.total) || 0,
      taxRate: requestPriceSummary.taxRate || (useNewStructure ? (priceData.taxPercentage || 0) / 100 : order.taxPercentage) || 0,
      installationFee: requestPriceSummary.installationFeeAmount || (useNewStructure ? priceData.installationAmount : 0),
      installationPercentage: requestPriceSummary.installationFee || (useNewStructure ? priceData.installationPercentage : 0)
  };

  let finalY = doc.lastAutoTable.finalY + 10;
  
  // check for page break
  if (finalY > 230) { // Reduced threshold to accommodate more lines
      doc.addPage();
      finalY = 20;
  }

  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text('Subtotal:', 140, finalY, { align: 'right' });
  doc.setFont(undefined, 'normal');
  doc.text(formatCurrency(summaryData.subTotal), 196, finalY, { align: 'right' });
  
  // Installation Fee
  if (summaryData.installationFee > 0) {
      finalY += 6;
      doc.setFont(undefined, 'bold');
      doc.text(`Installation (${summaryData.installationPercentage}%):`, 140, finalY, { align: 'right' });
      doc.setFont(undefined, 'normal');
      doc.text(formatCurrency(summaryData.installationFee), 196, finalY, { align: 'right' });
  }

  finalY += 6;
  doc.setFont(undefined, 'bold');
  doc.text(`Tax (${(parseFloat(summaryData.taxRate) * 100).toFixed(2)}%):`, 140, finalY, { align: 'right' });
  doc.setFont(undefined, 'normal');
  doc.text(formatCurrency(summaryData.tax), 196, finalY, { align: 'right' });

  finalY += 8;
  doc.setFontSize(12);
  doc.setFont(undefined, 'bold');
  doc.setTextColor(...COMPANY_COLOR);
  doc.text('Total:', 140, finalY, { align: 'right' });
  doc.text(formatCurrency(summaryData.total), 196, finalY, { align: 'right' });

  doc.setTextColor(...TEXT_COLOR);
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');

  // --- Append Terms (DocuSign-compatible) ---
  appendTermsForDocuSign(doc);

  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for(let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text(`Best National Carports - Page ${i} of ${pageCount}`, 105, 290, { align: 'center' });
  }

  return doc.output('datauristring');
};
